import type { IOrganizationOwnerRemovedNotificationData } from "@frontend-shared/types";
import { ShieldOff } from "lucide-react";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { NotificationCardShell } from "../NotificationCardShell";

interface IOrganizationOwnerRemovedCardProps {
  uuid: string;
  data: IOrganizationOwnerRemovedNotificationData;
  createdAt: string;
  isRead: boolean;
  onViewOrganization: (organizationUuid: string) => void;
}

const OrganizationOwnerRemovedCardComponent = ({
  uuid,
  data,
  createdAt,
  isRead,
  onViewOrganization,
}: IOrganizationOwnerRemovedCardProps): React.JSX.Element => {
  const { t } = useTranslation("notifications");

  const handleViewOrganization = useCallback(
    () => onViewOrganization(data.organizationUuid),
    [onViewOrganization, data.organizationUuid],
  );

  return (
    <NotificationCardShell
      uuid={uuid}
      variantTestId="organization_owner_removed"
      createdAt={createdAt}
      isRead={isRead}
      icon={<ShieldOff className="h-5 w-5" />}
      ctaLabel={t("view_organization")}
      onCtaClick={handleViewOrganization}
      body={t("type.organization_owner_removed.body", {
        organizationName: data.organizationName,
        removedByName: data.removedByName,
      })}
    />
  );
};

export const OrganizationOwnerRemovedCard = memo(
  OrganizationOwnerRemovedCardComponent,
);
